module.exports = __webpack_public_path__ + "static/media/extra_pillows_and_blankets.04af6013.svg";